module.exports = __webpack_public_path__ + "static/media/cultec-stormgenie-logo.844f30ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/cultec-stormgenie-logo.png
// module id = 512
// module chunks = 0